import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext.tsx';
import LoginModal from './LoginModal.tsx';
import { useIsMobile } from '../hooks/useMediaQuery.ts';

interface FloatingActionButtonProps {
  className?: string;
  style?: React.CSSProperties;
}

const FloatingActionButton: React.FC<FloatingActionButtonProps> = ({ className, style }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const history = useHistory();
  const { user } = useAuth();
  const isMobile = useIsMobile();

  const handleOptionClick = (path: string) => {
    setIsOpen(false);
    if (!user) {
      setShowLoginModal(true);
      return;
    }
    history.push(path);
  };

  return (
    <div className={className} style={{ position: 'relative', ...style }}>
      {/* 옵션 메뉴 */}
      {isOpen && (
        <>
          {/* 배경 오버레이 */}
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: 'rgba(0, 0, 0, 0.3)',
              zIndex: 998,
            }}
            onClick={() => setIsOpen(false)}
          />

          {/* 옵션 메뉴 */}
          <div
            style={{
              position: 'absolute',
              bottom: '70px',
              right: isMobile ? '-20px' : '0',
              background: '#ffffff',
              borderRadius: '15px',
              boxShadow: '0 8px 25px rgba(0, 0, 0, 0.15)',
              padding: '0.5rem',
              minWidth: isMobile ? '140px' : '160px',
              zIndex: 999,
              border: '1px solid #e8e6e1',
              animation: 'fadeInUp 0.3s ease-out',
            }}
          >
            <button
              onClick={() => handleOptionClick('/marketplace/register')}
              style={{
                width: '100%',
                padding: isMobile ? '0.8rem' : '1rem',
                background: 'transparent',
                border: 'none',
                borderRadius: '10px',
                cursor: 'pointer',
                fontSize: isMobile ? '0.8rem' : '0.9rem',
                color: '#2a2a2a',
                display: 'flex',
                alignItems: 'center',
                gap: '0.8rem',
                transition: 'background-color 0.2s ease',
                fontWeight: '500',
              }}
              onMouseEnter={e => ((e.target as HTMLElement).style.backgroundColor = '#f8f7f4')}
              onMouseLeave={e => ((e.target as HTMLElement).style.backgroundColor = 'transparent')}
            >
              <span style={{ fontSize: '1.2rem' }}>▤</span>도서 등록
            </button>

            <button
              onClick={() => handleOptionClick('/create-club')}
              style={{
                width: '100%',
                padding: isMobile ? '0.8rem' : '1rem',
                background: 'transparent',
                border: 'none',
                borderRadius: '10px',
                cursor: 'pointer',
                fontSize: isMobile ? '0.8rem' : '0.9rem',
                color: '#2a2a2a',
                display: 'flex',
                alignItems: 'center',
                gap: '0.8rem',
                transition: 'background-color 0.2s ease',
                fontWeight: '500',
              }}
              onMouseEnter={e => ((e.target as HTMLElement).style.backgroundColor = '#f8f7f4')}
              onMouseLeave={e => ((e.target as HTMLElement).style.backgroundColor = 'transparent')}
            >
              <span style={{ fontSize: '1.2rem' }}>◆</span>클럽 생성
            </button>
          </div>
        </>
      )}

      {/* 메인 + 버튼 */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        style={{
          width: '56px',
          height: '56px',
          borderRadius: '50%',
          background: isOpen ? '#1a1a1a' : '#2a2a2a',
          border: 'none',
          color: '#ffffff',
          fontSize: '1.5rem',
          cursor: 'pointer',
          boxShadow: isOpen
            ? '0 6px 20px rgba(0,0,0,0.3)'
            : '0 4px 12px rgba(0,0,0,0.2)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          transform: isOpen ? 'rotate(45deg) scale(1.1)' : 'rotate(0deg) scale(1)',
          fontWeight: '300',
        }}
        onMouseEnter={e => {
          if (!isOpen) {
            (e.target as HTMLElement).style.transform = 'scale(1.1)';
            (e.target as HTMLElement).style.boxShadow = '0 6px 16px rgba(0,0,0,0.3)';
          }
        }}
        onMouseLeave={e => {
          if (!isOpen) {
            (e.target as HTMLElement).style.transform = 'scale(1)';
            (e.target as HTMLElement).style.boxShadow = '0 4px 12px rgba(0,0,0,0.2)';
          }
        }}
      >
        +
      </button>

      {/* CSS 애니메이션 */}
      <style>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>

      <LoginModal isOpen={showLoginModal} onClose={() => setShowLoginModal(false)} />
    </div>
  );
};

export default FloatingActionButton;
